module.exports = __webpack_public_path__ + "static/media/support-icon-active.b5084d1a.svg";